import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../../helpers/react.js";
import { useIndexTableDisabled } from "../IndexTableContext.js";
import '../../../assets/index20.css';const badgeCell = "_badgeCell_dj1po_1";
const disabled = "_disabled_dj1po_9";
const s = {
  badgeCell,
  disabled
};
const IndexTableCellBadge = forwardRef(({ className, children, ...rest }, ref) => {
  const disabled2 = useIndexTableDisabled(rest);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...rest,
      ref,
      className: clsx(
        s.badgeCell,
        {
          [s.disabled]: disabled2
        },
        className
      ),
      children
    }
  );
});
export {
  IndexTableCellBadge
};
